import resourceNamePluralizer from "@/utils/resource-name-pluralizer";
import camelCase from "lodash/camelCase";
import uniqBy from "lodash/uniqBy";

const actionMapper = {
  index: (data, resource) => {
    const pluralResource = resourceNamePluralizer.get(
      camelCase(resource.resourceName())
    );
    return data[pluralResource]
      .filter(obj => obj)
      .map(obj => obj && new resource(obj));
  },
  indexUnwrapped: (data, resource) => {
    return data.map(obj => new resource(obj));
  },
  taxonomy: (data, resource) => {
    return data.taxonomy.values.map(obj => new resource(obj));
  },
  getProfile: (data, resource) => {
    const profileId = data["_id"];
    const name = data["coachname"] || data["athletename"] || data["name"];
    localStorage["profile-id"] = profileId;
    localStorage["profile-name"] == name;
    if (data["CollegeId"])
      localStorage["college-id"] =
        data["CollegeId"] && data["CollegeId"]["_id"];
    if (data["clubId"]) {
      localStorage["club-id"] = data["clubId"] && data["clubId"]["_id"];
      localStorage["coach-downgraded"] =
        data["clubId"] && data["clubId"]["coachDowngraded"];
    }
    return new resource(data);
  },
  delete: (data, resource) => {
    return new resource(data);
  },
  create: (data, resource) => {
    return new resource(data);
  },
  show: (data, resource) => {
    return new resource(data);
  },
  wrappedShow: (data, resource) => {
    return new resource(
      data[resourceNamePluralizer.get(resource.resourceName())]
    );
  },
  wrappedShow2: (data, resource) => {
    return new resource(data[resource.resourceName()]);
  },
  update: (data, resource) => {
    return new resource(data);
  },
  addToList: (data, resource, store) => {
    let newStore = store;
    newStore.unshift(new resource(data[resource.resourceName()]));
    return newStore;
  },
  edit: (data, resource, store) => {
    let index = store.findIndex(
      item => item.id === data[resource.resourceName()]._id
    );
    store.splice(index, 1, new resource(data[resource.resourceName()]));
    return store;
  },
  editImage: (data, resource, store) => {
    let index = store.findIndex(item => item.id === data._id);
    store.splice(index, 1, new resource(data));
    return store;
  },
  enable: () => {
    return true;
  },
  randomObjectWrappedIndex: data => {
    return Object.values(data)[0]
      ? Object.values(data)[0]
      : Object.values(data);
  },
  resourceObjectWrappedShow: (data, resource) => {
    let wrappedData = Object.values(data)[0]
      ? Object.values(data)[0]
      : Object.values(data);
    return new resource(wrappedData);
  },
  resourceObjectWrappedIndex: (data, resource) => {
    let wrappedData = Object.values(data)[0]
      ? Object.values(data)[0]
      : Object.values(data);
    return wrappedData.map(item => new resource(item));
  },
  messagePageShow: data => {
    return data.page;
  },
  infiniteMessageScroll: (data, resource, state) => {
    const currentData = data.map(obj => new resource(obj));
    let joinedData = uniqBy(
      [...state.allMessages, ...data.map(obj => new resource(obj))],
      "id"
    );
    joinedData = joinedData.sort(
      (prev, next) =>
        Number(new Date(prev.createdAt)) - Number(new Date(next.createdAt))
    );
    return { allMessages: joinedData, current: currentData };
  },
  contactListInfiniteScroll: (data, resource, state) => {
    const unreadCount = data.total;
    const currentData = data.chatList.map(obj => new resource(obj));
    const joinedData = uniqBy([...state.allContacts, ...currentData], "id");
    return { allContacts: joinedData, current: currentData, unreadCount };
  },
  mainAthleteWrappedMutation: (data, resource) => {
    return new resource(data["mainAthlete"]);
  }
};

const sharedMutations = {
  PENDING: (state, loadingKey) => {
    if (typeof state[loadingKey] === "boolean") state[loadingKey] = true;
  },
  SUCCESS: (
    state,
    {
      resource,
      storeKey,
      metaKey,
      data,
      headers,
      action,
      results,
      unReadNotifications
    }
  ) => {
    state[storeKey] = actionMapper[action]
      ? actionMapper[action](data, resource, state[storeKey])
      : data;
    if (state[metaKey])
      state[metaKey] = {
        total: results,
        unReadNotifications: unReadNotifications,
        ...headers
      };
  },
  RESOLVE_PENDING: (state, loadingKey) => {
    if (typeof state[loadingKey] === "boolean") state[loadingKey] = false;
  }
};

export default sharedMutations;
